export const getters = {
    getUserMessageArray: state => state.userMessageArray,
    getUserArray: state => state.userArray,
    getUserRoles: state => state.userRoles
}